import { FilterType } from "src/api/types";
import RolesFilter from "src/components/RolesFilter";
import { FIRST_NAME, LAST_NAME, ROLES } from "src/constants/searchParams";

export const filters: FilterType[] = [
  {
    name: FIRST_NAME,
    placeholder: "First name",
    type: "text",
  },
  {
    name: LAST_NAME,
    placeholder: "Last name",
    type: "text",
  },
  {
    name: ROLES,
    placeholder: "Roles",
    type: "custom",
    component: RolesFilter,
  },
];
